import {API_URL} from "../config";
import axios from "../utils/axios";

class JobsService
{
    startDailyVerification() {
        return axios.post(API_URL + "/Jobs/StartDailyVerification");
    }

    verifyParkingEvent(id) {
        return axios.post(API_URL + "/Jobs/VerifyParkingEvent/" + id);
    }
}

export default JobsService;